import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import CommonSelectMultiple from "../../../components/forms/CommonSelectMultiple";
import { handleChangeMultipleSelect } from "../../../helpers/handleFormChanges";
import CommonButton from "../../../components/buttons/CommonButton";

function UsuariosModal({ modalHook, usuarios, valuesHook, vincularUsuarios }) {
  const { usuariosModal, setUsuariosModal } = modalHook;
  const { values, setValues } = valuesHook;

  const selectedUsuarios = React.useMemo(() => {
    const result =
      values?.usuarios
        ?.map((uid) => usuarios.find((usuario) => usuario.uid === uid))
        .filter(Boolean) || [];
    return result;
  }, [values?.usuarios, usuarios]);

  return (
    <CommonModal
      title="Usuários vinculados"
      is_open_modal={usuariosModal}
      set_is_open_modal={setUsuariosModal}
      size="md"
      buttons={
        <CommonButton color="success" onClick={vincularUsuarios}>
          Vincular
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-12">
          <div className="mb-12">
            <label htmlFor="" className="form-label">
              Os Usuários selecionáveis já são cadastrados no sistema, caso
              necessite de um novo usuário selecione o botão Novo Usuário, ao
              cadastrar um novo usuário ele será vinculado automaticamente a
              empresa em processo de abertura.
            </label>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <CommonSelectMultiple
            label="Selecione os Usuários"
            id="usuarios"
            value={selectedUsuarios}
            onChange={(e, newValue) => {
              handleChangeMultipleSelect(
                values,
                setValues,
                "usuarios",
                newValue,
                "uid"
              );
            }}
            data={usuarios}
            optionLabel="nome"
            renderOptionLabel={(option) => `${option.nome} (${option.email})`}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 mt-2">
          <div className="mb-3 float-end">
            <CommonButton
              color="warning"
              onClick={() => {
                setValues((prevValues) => ({
                  ...prevValues,
                  usuarios: [],
                }));
              }}
            >
              Limpar
            </CommonButton>
          </div>
        </div>
      </div>
    </CommonModal>
  );
}

UsuariosModal.propTypes = {
  modalHook: PropTypes.shape({
    usuariosModal: PropTypes.bool.isRequired,
    setUsuariosModal: PropTypes.func.isRequired,
  }).isRequired,
  usuarios: PropTypes.object.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  vincularUsuarios: PropTypes.func.isRequired,
};

export default UsuariosModal;
